import Hammer from 'hammerjs';
import TweenMax from "gsap/TweenMax";
import ScrollToPlugin from "gsap/ScrollToPlugin";

class Slider
{
	constructor(container)
	{
		this._container = container;

		this._previousSlide = this._previousSlide.bind( this );
		this._nextSlide = this._nextSlide.bind( this );
    this._openLink = this._openLink.bind( this );
    this._scrollTo = this._scrollTo.bind( this );

		this._init();
	}

	_init()
	{
		this._currentIdx = -1;
		TweenMax.lagSmoothing(0)
		
		let slides = this._container.querySelectorAll('.Slider_slide');
		this._slides = Array.from(slides)
		// this._slides.reverse();

		let items = this._container.querySelectorAll('.Slider_counters_count');
		this._navItems = Array.from(items);
		this._navItems[0].classList.add('actif');

		for (let i = 0; i < this._navItems.length; i++) {
			this._navItems[i].addEventListener('click', ( e ) => { this.goSlideIdx( e.target.dataset.idx )} )
		}

		for (let i = 0; i < this._slides.length; i++) {
			TweenMax.set(this._slides[i], {zIndex: 1, autoAlpha:0});
		}

		this._container.querySelector('.Slider_scroll').addEventListener('click', this._scrollTo)

		if(this._slides.length > 1)
		{
			this.mc = new Hammer(this._container);

			this.mc.on('swipeleft', this._nextSlide);
			this.mc.on('swiperight', this._previousSlide);

			this._container.querySelector('.Slider_right').addEventListener('click', this._nextSlide)
			this._container.querySelector('.Slider_left').addEventListener('click', this._previousSlide)

			this.goSlideIdx( 0 )
		}

		window.addEventListener('resize', this._onResize.bind(this))
	}

	_onResize()
	{
		let slide = this._slides[this._currentIdx].querySelector('img')
		let slideR = this._slides[this._currentIdx].querySelector('.Section_col-right')
		let slideL = this._slides[this._currentIdx].querySelector('.Section_col-left')
		let mobile = slide.dataset.mobile
		let desktop = slide.dataset.desktop

		if(window.innerWidth < 800)
		{
			slideR.style.height = this._slides[this._currentIdx].offsetHeight - slideL.offsetHeight + "px"
			console.log(this._slides[this._currentIdx].offsetHeight - slideL.offsetHeight + "px")
		}
		else
			slideR.style.height = "100%"

		if(window.innerWidth < 800 && mobile != "")
		{
			slide.src = mobile
		}else
		{
			slide.src = desktop
		}
	}

	_scrollTo()
	{
		TweenMax.to(window, 1, { scrollTo:window.innerHeight - 60 });
	}

	_nextSlide()
	{
		this.goSlideIdx( this._currentIdx < this._slides.length - 1 ? this._currentIdx + 1 : 0 )
	}

	_previousSlide()
	{
		this.goSlideIdx( this._currentIdx === 0 ? this._slides.length - 1 : this._currentIdx-1 )
	}

	_openLink(e)
	{
		let el = e.currentTarget
		if(el.dataset.link)
			document.location.href= el.dataset.link;
	}
	
	goSlideIdx( idx )
	{
		if(this._state) return

		if( this._currentIdx > -1 )
		{
			this._navItems[this._currentIdx].classList.remove('actif');
			TweenMax.to(this._slides[this._currentIdx], 1, {zIndex: 1, autoAlpha:0, ease:Quint.easeOut});
		}

		this._currentIdx = parseInt(idx)

		this._onResize()

		this._state = true
    this._navItems[this._currentIdx].classList.add('actif');
    let img = this._slides[this._currentIdx].querySelector('.Section_col-right')
		
		TweenMax.fromTo(this._slides[this._currentIdx], 1.5, {autoAlpha: 0}, {delay: 0.3, zIndex: 2, autoAlpha: 1, ease:Quint.easeOut, onComplete: () => { this._state = false }});
    TweenMax.fromTo(this._slides[this._currentIdx].querySelector('.Section_heading'), 1, {y:60}, {y:0, delay: 0.3, ease:Quint.easeOut});
    
    if(img)
      TweenMax.fromTo(img, 1.5, {x:'120%'}, {x:"0%", delay: 0.6, ease:Quint.easeOut});

		if(this._timer) clearTimeout(this._timer)
		this._timer = setTimeout( () => { this._nextSlide() }, 5000)

		this._slides[this._currentIdx].addEventListener('click', this._openLink)		
	}
}

module.exports = Slider;


// WEBPACK FOOTER //
// ./src/js/components/Slider.js